(ns ycweb.app.admin.buying.rangereview.selectproducts
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.buying.rangereview.common :as rangecmn]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(defn flatten-list [{:item-line/keys [product variation]}]
  (merge product variation))

(defn variation-update-cell [tag-type tag app-atom row col]
  (let [action-atom (cmn/action-cursor app-atom)
        item-atom (rum/cursor-in action-atom [:variations (:ent/uuid row)])]
    [:label
     {:for (str tag-type "-" (:ent/uuid row)), :class (yuc/bem :checkbox-label [:inline])}
     [:input.checkbox
      (merge
        (input-forms/checkbox-props
          (rum/cursor-in item-atom [:item-line/variation tag])
          #(grid/dispatch-action app-atom :admin.rangereview/update-variation {:variation-uuid (:ent/uuid row)})
          nil
          (cond
            (and (:variation/included? row) (:variation/stores-ranged row) (pos? (:variation/stores-ranged row)))
            false

            (= tag :variation/store-remove?)
            true

            (or (:variation/included? row) (= tag :variation/included?))
            false

            :else
            true)
          false)
        {:id (str tag-type "-" (:ent/uuid row))})]
     [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
     [:span.u-hidden-from-view tag-type]]))

(def range-review-select-variations-table-fns
  {:column-fns
   {:include-fn (partial variation-update-cell "Include" :variation/included?)
    :core-fn (partial variation-update-cell "Core" :variation/core?)
    :seasonal-fn (partial variation-update-cell "Seasonal" :variation/seasonal?)
    :derange-fn (partial variation-update-cell "Derange" :variation/store-remove?)
    :delist-fn (partial variation-update-cell "Delist" :variation/delist?)

    :image-fn
    (fn [app-atom row col value]
      [:a.u-block-link
       {}
       (web-common/lazy-image app-atom
         (if (:doc/public-id value)
           (:doc/public-id value)
           "ui-resources/admin-dashboard/no-image")
         {:class ["trend-card__image"]}
         {:w 96
          :h 96
          :q "auto"
          :alt ""})])

    :brand-fn
    (fn [app-atom row col value]
      [:b value])

    :name-ex-brand-fn
    (fn [app-atom row col value]
      (str value " - " (str (:variation/code row))))

    :tag-fn
    (fn [app-atom row col value]
      (let [{:product/keys [edison-stone? exclusive?]} row
            {:variation/keys
             [included? core? seasonal? store-remove? delist?
              stores-ranged] :or {included? false}} row]
        [:div
         (when false
           (rangecmn/product-list-pill "Newly listed" :peacock))
         (when edison-stone?
           (rangecmn/product-list-pill "Edison Stone" :oil))
         (when exclusive?
           (rangecmn/product-list-pill "Exclusive" :greenery))
         (when core?
           (rangecmn/product-list-pill "Core" :casablanca :oil))
         (when seasonal?
           (rangecmn/product-list-pill "Seasonal" :terracotta))
         (when delist?
           (rangecmn/product-list-pill "Delist" :red))
         (when (and store-remove? (not delist?))
           (rangecmn/product-list-pill "Derange Store" :red))
         (when (and included? (= (or stores-ranged 0) 0) (not delist?) (not store-remove?))
           (rangecmn/product-list-pill "Proposed" :iris))]))

    :status-render-fn
    (fn [app-atom row col value]
      [:b {:class (yuc/bem :text-status [(when (= value "Live") :success)])} (if (:variation/sell-out? row) "Sell Out" value)])

    :price-sort-fn
    (fn [_ row value]
      value)}

   :config-fns
   {:filter-rows
    (fn [app-atom variations]
      (let [action-atom (cmn/action-cursor app-atom)
            view-products (cmn/curact action-atom [:view-products])]
        (->>
          variations
          (rangecmn/filter-products view-products)
          (map flatten-list)
          (sort-by :product/name-ex-brand))))

    :history-status-cell-fn
    (fn [app-atom row]
      (let [fetching-history? (cmn/curact (cmn/action-cursor app-atom) :fetching-history?)]
        [(when fetching-history? :u-bg-red)]))

    :row-class-fn
    (fn [app-atom row]
      (yuc/bem :row-status [(when (:variation/included? row) :is-success)]))}})

(def range-review-add-variations-table-config
  {:table-name :admin.rangereview/add-products
   :row-id :ent/uuid
   :row-class-k :row-class-fn
   :data-source {:cursor [:admin.rangereview/select-products :variations]}
   :options
   {:order :desc
    :sticky-header? true
    :filter :filter-rows}
   :column-defs
   [{:key :variation/included? :title "Include" :scope "col" :no-wrap true
     :render {:render-k :include-fn}}
    {:key :variation/core? :title "Store Core" :scope "col" :no-wrap true
     :render {:render-k :core-fn}}
    {:key :variation/seasonal? :title "Seasonal" :scope "col" :no-wrap true
     :render {:render-k :seasonal-fn}}
    {:key :ent/image :title "Product Image" :scope "col" :no-wrap true
     :render {:render-k :image-fn}
     :sorting-key [:ent/image :doc/public-id]}
    {:key :variation/tags :title "Attributes" :scope "col" :no-wrap true
     :render {:render-k :tag-fn}}
    {:key :product/brand-name :title "Brand" :scope "col" :no-wrap true
     :render {:render-k :brand-fn}}
    {:key :product/name-ex-brand :title "Product Name" :scope "col" :no-wrap true
     :render {:render-k :name-ex-brand-fn}}
    {:key :variation/colour :title "Colour" :no-wrap true}
    {:key :variation/size :title "Size" :no-wrap true}
    {:key :variation/price :title "Retail Price" :type :tocurrency :scope "col" :no-wrap true}
    {:key :variation/margin :title "Margin" :type :percentage :scope "col" :no-wrap true}
    {:key :variation/cost-price :title "Cost Price" :type :tocurrency :scope "col" :no-wrap true}]})

(def range-review-select-variations-table-config
  {:table-name :admin.rangereview/select-products
   :row-id :ent/uuid
   :row-class-k :row-class-fn
   :data-source {:cursor [:admin.rangereview/select-products :variations]}
   :options
   {:order :desc
    :filter :filter-rows
    :sticky-header? true}
   :colgroup
   [:colgroup
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col {:style {:width "96px"}}]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]
    [:col]]

   :column-defs
   [{:key :variation/included? :title "Include" :scope "col" :no-wrap true
     :render {:render-k :include-fn}}
    {:key :variation/core? :title "Store Core" :scope "col" :no-wrap true
     :render {:render-k :core-fn}}
    {:key :variation/seasonal? :title "Seasonal" :scope "col" :no-wrap true
     :render {:render-k :seasonal-fn}}
    {:key :variation/store-remove? :title "Store Remove" :scope "col" :no-wrap true
     :render {:render-k :derange-fn}}
    {:key :variation/delist? :title "Delist"
     :render {:render-k :delist-fn}}
    {:key :product/edit-link :title "Edit" :type :link :redirect? true}
    {:key :ent/image :title "Product Image" :scope "col" :no-wrap true
     :render {:render-k :image-fn}
     :sorting-key [:ent/image :doc/public-id]}
    {:key :variation/tags :title "Attributes" :scope "col" :no-wrap true
     :render {:render-k :tag-fn}}
    {:key :product/brand-name :title "Brand" :scope "col" :no-wrap true
     :render {:render-k :brand-fn}}
    {:key :product/name-ex-brand :title "Product Name" :scope "col" :no-wrap true
     :render {:render-k :name-ex-brand-fn}}
    {:key :variation/size :title "Size" :scope "col" :no-wrap true}
    {:key :variation/colour :title "Colour" :scope "col" :no-wrap true}
    {:key :variation/price :title "Retail Price" :type :tocurrency :scope "col" :no-wrap true}
    ;; {:key :variation/avg-margin-for-period :title "Margin" :type :percentage :scope "col" :no-wrap true}
    {:key :variation/margin :title "Margin" :type :percentage :scope "col" :no-wrap true}
    {:key :variation/cost-price :title "Cost Price" :type :tocurrency :scope "col" :no-wrap true}
    {:key :variation/total-income-for-period :title "Total Income" :type :tohumancurrency :scope "col" :no-wrap true}
    {:key :variation/total-sales-for-period :title "Total Units Sold" :type :number :scope "col" :no-wrap true}
    {:key :variation/online-sellability :title "Online Sellability" :type :percentage :scope "col" :no-wrap true}
    {:key :variation/store-income-for-period :title "Store Income" :type :tohumancurrency :scope "col" :no-wrap true}
    {:key :variation/store-sales-for-period :title "Store Units" :type :number :scope "col" :no-wrap true}
    {:key :variation/store-sellability :title "Store Stocked" :type :number :scope "col" :no-wrap true}
    {:key :variation/status :title "Live Status" :no-wrap true :render {:render-k :status-render-fn} :scope "col"}
    {:key :variation/time-live :title "Time Live" :scope "col" :no-wrap true}
    {:key :variation/stores-ranged :title "Stores Ranged" :type :number :default 0 :scope "col" :no-wrap true}
    {:key [:product/product-type :type/price] :title "Grade" :scope "col" :no-wrap true}
    {:key [:product/product-type :ent/display-name] :title "Product Type" :scope "col" :no-wrap true}
    {:key [:product/primary-category :ent/display-name] :title "Primary Category" :scope "col" :no-wrap true}]})

;; Review
(rum/defc rangereview-review-select-products < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        category (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])
        view-products (cmn/curact action-atom [:view-products])]
    [:div.admin-react-wrapper__content
     (rangecmn/rangereview-header app-atom :product nil)
     [:div
      {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Live Products"
          {:on-click #(swap! action-atom assoc :view-products :live)
           :style (if (= view-products :live) :primary :secondary)
           :size :default
           :full true})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Not Live Products"
          {:on-click #(swap! action-atom assoc :view-products :not-live)
           :style (if (= view-products :not-live) :primary :secondary)
           :size :default
           :full true})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Suggested Products"
          {:on-click #(swap! action-atom assoc :view-products :suggested)
           :style (if (= view-products :suggested) :primary :secondary)
           :size :default
           :full true})]]
      (when (= view-products :suggested)
        [:div
         {:class (yuc/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (buttons/button-web "Add Product"
            {:on-click #(grid/dispatch-action app-atom :admin.rangereview/add-newproduct {})
             :style (if (= view-products :live) :primary :cta)
             :size :default
             :icon :plus
             :full true})]])]

     (when (or (= view-products :live) (= view-products :not-live))
       (datatables/table app-atom
         :admin.rangereview/select-products
         range-review-select-variations-table-fns))

     (when (= view-products :suggested)
       (datatables/table app-atom
         :admin.rangereview/add-products
         range-review-select-variations-table-fns))

     [:div.admin-action-bar.u-do-not-print
      [:div
       {:class
        (yuc/bem
          :flex-grid-group
          [:row-reversed :align-between :valign-middle :flush])}
       [:div.u-min-width-240
        {:class (yuc/bem :flex-grid-block [:fluid :flush])}
        [:div.flex-grid-content
         [:div
          {:class
           (yuc/bem :flex-grid-group [:row-reversed :valign-middle :flush])}
          [:div.u-min-width-240
           {:class (yuc/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "View review plan"
              (merge
                (urlstate/href-props app-atom "rangereview" "digital" {:review-uuid (:ent/uuid range-review) :category-uuid (:ent/uuid category)})
                {:style :primary
                 :size :default
                 :full true
                 :icon :arrow-right
                 :icon-placement :right}))]]]]]
       (when (:category/prev-level category)
         [:div.u-min-width-240
          {:class (yuc/bem :flex-grid-block [:fluid :flush])}
          [:div.flex-grid-content
           (buttons/button-web "Back"
             (merge
               (urlstate/href-props app-atom "rangereview" "category" {:review-uuid (:ent/uuid range-review) :category-uuid (:category/prev-level category)})
               {:style :secondary
                :size :default
                :full true
                :icon :arrow-left}))]])]]
     (toaster/loading-overlay app-atom :admin.rangereview/select-products)]))

(defmethod flow/render-screen :admin.rangereview/select-products [app-atom _]
  (rangereview-review-select-products app-atom))

(defmethod t/transition-open :admin.rangereview/select-products [app-atom _ params]
  (datatables/initiate app-atom range-review-select-variations-table-config {})
  (datatables/initiate app-atom range-review-add-variations-table-config {})
  (toaster/open-overlay app-atom :admin.rangereview/select-products)

  (let [process-atom (cmn/process-cursor app-atom)
        param-brand-ids (rangecmn/extract-param-brand-ids app-atom)]

    (swap! process-atom assoc :range-review/selected-brands param-brand-ids)
    (comms/send :admin.rangereview/fetch-category
      (yuc/maybe assoc params
        :filter-brand-ids param-brand-ids))))

(defmethod t/transition-close :admin.rangereview/select-products [app-atom _]
  (swap! app-atom update-in [:admin.rangereview/select-products] dissoc :variations))

(defmethod comms/receive :admin.rangereview/fetch-category
  [app-atom {:keys [range-review category brands growth category-stats category-stats-prev]}]
  (let [action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)
        selected-brands (set (cmn/curact process-atom :range-review/selected-brands))
        brands-idx (rangecmn/add-selected-brands brands selected-brands)]

    (swap! action-atom assoc
      :range-review range-review
      :category category
      :growth growth
      :category-stats category-stats
      :category-stats-prev category-stats-prev
      :filters
      {:brands-idx brands-idx}))

  (grid/dispatch-action app-atom :admin.rangereview/fetch-products
    {:view-products :live :category-uuid (:category-uuid (:ent/uuid category))}))

(defmethod grid/action :admin.rangereview/fetch-products [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        category (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])
        view-products (:view-products config)
        variations (cmn/curact action-atom [:variations view-products])
        param-brand-ids (rangecmn/extract-param-brand-ids app-atom)]

    (swap! process-atom assoc :range-review/selected-brands param-brand-ids)
    (swap! action-atom assoc :view-products view-products)
    (when (or (nil? variations) (empty? variations))
      (toaster/open-overlay app-atom :admin.rangereview/select-products)
      (comms/send :admin.rangereview/fetch-products
        {:view-products view-products
         :category-uuid (:ent/uuid category)
         :review-uuid (:ent/uuid range-review)
         :filter-brand-ids param-brand-ids}))))

(defmethod comms/receive :admin.rangereview/fetch-products [app-atom e]
  (let [action-atom (cmn/action-cursor app-atom)
        category (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])
        view-products (cmn/curact action-atom [:view-products])]
    (swap! (cmn/action-cursor app-atom) assoc
      :variations (:variations e)
      :avg-sellability (:avg-sellability e)
      :fetching-history? true)
    (when (:variations e)
      (comms/send :admin.rangereview/fetch-history
        {:view-products view-products
         :vids (map :item-line/variation-id (vals (:variations e)))
         :category-uuid (:ent/uuid category)
         :review-uuid (:ent/uuid range-review)})))
  (toaster/close-overlay app-atom :admin.rangereview/select-products))

(defmethod comms/receive :admin.rangereview/fetch-history [app-atom e]
  (doseq [[vid history] (:history e)]
    (swap! (cmn/action-cursor app-atom) update-in [:variations (:variation/uuid history) :item-line/variation] merge
      (select-keys history
        [:variation/store-sellability :variation/online-sellability :variation/margin
         :variation/prev-store-sellability :variation/prev-online-sellability])))
  (swap! (cmn/action-cursor app-atom) assoc :fetching-history? false))

(defmethod grid/action :admin.rangereview/update-variation [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        item-atom (rum/cursor-in action-atom [:variations (:variation-uuid config)])
        range-review (cmn/curact action-atom [:range-review])
        {:variation/keys [included? core? seasonal? store-remove? delist?]}
        (:item-line/variation (cmn/curact item-atom []))
        tags (remove nil? [(when core? :core) (when seasonal? :seasonal) (when store-remove? :store-remove) (when delist? :delist)])]

    (cond
      (not included?)
      (comms/send :admin.rangereview/remove-variation
        {:review-uuid (:ent/uuid range-review)
         :variation-uuid (:variation-uuid config)})

      :else
      (comms/send :admin.rangereview/update-variation
        {:review-uuid (:ent/uuid range-review)
         :variation-uuid (:variation-uuid config)
         :tag tags}))))

(defmethod comms/receive :admin.rangereview/update-variation [app-atom e])
